import { Button } from "@/components/ui/button";

/** One optional continuation read failed; its readable siblings stay mounted. */
export function SessionReadFailure({ part, retry }: { part: "previous session" | "next scheduled session" | "cancelled sessions" | "previous and next session"; retry?: () => void }) {
  return <p className="text-meta text-muted-foreground">The {part} could not be read.{retry && <> <Button variant="subtle" size="sm" onClick={retry}>Retry {part}</Button></>}</p>;
}
